import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import BottomNav from "./components/BottomNav";
import MiniPlayer from "./components/MiniPlayer";
import FullPlayer from "./components/FullPlayer";
import MusicPlayerEngine from "./components/MusicPlayerEngine";
import AutoplayGate from "./components/AutoplayGate";
import useMediaSession from "./hooks/useMediaSession";
import musicPlayerStore from "../zustand/musicPlayer.store";
import styles from "./MobileLayout.module.scss";

const MobileLayout = ({ children }) => {
  useMediaSession();

  const [showFullPlayer, setShowFullPlayer] = useState(false);
  const { songs, isLoading } = musicPlayerStore((state) => ({
    songs: state.songs,
    isLoading: state.isLoading,
  }));
  const { pathname } = useLocation();

  useEffect(() => {
    setShowFullPlayer(false);
  }, [pathname]);

  const hasSongs = songs?.length > 0;

  const openFullPlayer = useCallback(() => {
    if (hasSongs) setShowFullPlayer(true);
  }, [hasSongs]);

  const closeFullPlayer = useCallback(() => {
    setShowFullPlayer(false);
  }, []);

  return (
    <AutoplayGate>
      <div className={styles.layout}>
        <MusicPlayerEngine />

        <div className={styles.content}>{children}</div>

        {hasSongs && <MiniPlayer onTap={openFullPlayer} />}

        {showFullPlayer && (
          <FullPlayer onClose={closeFullPlayer} />
        )}

        <BottomNav />
      </div>
    </AutoplayGate>
  );
};

export default MobileLayout;
